import { useEffect, useState } from 'react'

import { CountryPreferenceStrippedDto } from '@model/CountryDto'

import { useGeolocation } from './useGeolocation'

interface UseGeolocationCountryCodeResult {
  countryCode: string | undefined
  isLoading: boolean
  isFailed: boolean
}

export const useGeolocationCountryCode = (
  countries: CountryPreferenceStrippedDto[],
  enabled: boolean = true
): UseGeolocationCountryCodeResult => {
  const {
    countryCodeIso3,
    isLoading: geolocationLoading,
    isFailed: geolocationFailed,
  } = useGeolocation(enabled)
  const [countryCode, setCountryCode] = useState<string | undefined>()

  useEffect(() => {
    if (!enabled || countries.length === 0 || !countryCodeIso3) {
      return
    }

    const countryByGeolocation = countries.find(
      (x) => x.country.id.toLowerCase() === countryCodeIso3.toLowerCase()
    )

    if (countryByGeolocation) {
      setCountryCode(countryByGeolocation.phoneCode)
    }
  }, [countryCodeIso3, countries, enabled])

  return {
    countryCode,
    isLoading: geolocationLoading,
    isFailed: geolocationFailed,
  }
}
